import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_8 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_9 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_etapa_producao = _resolveComponent("selecionar-etapa-producao")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "60%",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Tipo de Produção "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.tipoProducao.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tipoProducao.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativa",
          "un-checked-children": "Inativa",
          disabled: !_ctx.state.editavel
        }, null, 8, ["checked", "disabled"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                  || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.tipoProducao.nome) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, _hoisted_4), [
                          [_vModelText, _ctx.state.tipoProducao.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.tipoProducao.apontamentoAutomatico,
                          "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tipoProducao.apontamentoAutomatico) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Apontamento Automático")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "Etapa",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_etapa_producao, {
                          codigoSelecionado: _ctx.state.etapa,
                          "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.etapa) = $event)),
                          descricaoSelecionado: _ctx.state.descricaoEtapa,
                          "onUpdate:descricaoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.descricaoEtapa) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas
                        }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "",
                      class: "ss-margin-campos",
                      style: {"margin-bottom":"0","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary",
                          style: {"width":"100%"},
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.adicionar && _ctx.adicionar(...args)))
                        }, _toDisplayString(_ctx.state.etapaSelecionada === -1 ? 'Adicionar' : 'Editar'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, {
                  titulo: "ETAPAS",
                  class: "ss-padding-separacao-esquerda"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                      "data-source": _ctx.state.tipoProducao.etapas,
                      rowKey: "codigo",
                      pagination: false,
                      size: "small",
                      loading: _ctx.gradeBase.buscandoDados
                    }, {
                      bodyCell: _withCtx(({ column, index }) => [
                        (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.editar(index))
                              }, [
                                _createVNode(_component_icone, { nome: "editar" })
                              ], 8, _hoisted_10),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.excluir(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_11)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}